import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useEffect } from "react";
import { SessionResults } from "./BilanResultTabs";

export function SelectionResults ({
  setSessionResults,
  sessionsResults,
  currentSession,
}: {
  sessionsResults: SessionResults[];
  setSessionResults: (sessionResult: SessionResults) => void;
  currentSession?: SessionResults;
}) {
  useEffect(() => {
    if (Array.isArray(sessionsResults) && sessionsResults.length > 0) {
      const sortedResults = sessionsResults
        .filter((option) => option.fiable)
        .sort(
          (a, b) =>
            new Date(b.sessionDate).getTime() -
            new Date(a.sessionDate).getTime()
        );

      if (sortedResults.length > 0) {
        setSessionResults(sortedResults[0]);
      }
    }
  }, [sessionsResults, setSessionResults]);

  if (!Array.isArray(sessionsResults)) {
    console.error("selections is not an array:", sessionsResults);
    return null;
  }

  return (
    <div className="flex flex-col items-center w-full">
      {/* <div className="w-full max-w-lg p-6 bg-white border border-gray-200 rounded shadow-md"> */}
      <Select
        value={currentSession?.id.toString() || ""}
        onValueChange={(value) => {
          const filteredSelection = sessionsResults.find(
            (option) => option.id.toString() === value
          ) as SessionResults;
          setSessionResults(filteredSelection);
        }}
      >
        <SelectTrigger
          onClick={(e) => {
            e.stopPropagation(); // Empêche la propagation du clic au composant sous-jacent
          }}
        >
          <SelectValue placeholder="Sélectionner" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="none">Aucune sélection</SelectItem>
          {sessionsResults
            .filter((option) => option.fiable)
            .sort((a, b) => new Date(b.sessionDate).getTime() - new Date(a.sessionDate).getTime())
            .map((option) => (
              <SelectItem key={option.id} value={option.id.toString()}>
                <div className="flex items-center justify-between w-full">
                  <span className="font-medium">
                    {option.sessionType} #{option.order}
                  </span>
                  <span className="text-sm text-gray-600">
                    {" " + option.accountUsed} • {new Date(option.sessionDate).toLocaleDateString("fr-FR")} • {option.screenUsed}
                  </span>
                </div>
              </SelectItem>
            ))}
        </SelectContent>
      </Select>
    </div>
  );
}
